import Slider from "react-slick";
// import { Link } from 'react-router-dom';
import React, { Component } from "react";

export default class AsNavFor extends Component {
    constructor(props) {
        super(props);
        this.state = {
          nav1: null,
          nav2: null
        };
      }
    
      componentDidMount() {
        this.setState({
          nav1: this.slider1,
          nav2: this.slider2
        });
      }
      render() {
  return (
    <div>
      <div className="product_slider_box">
          <Slider className="slideone" asNavFor={this.state.nav2} ref={slider => (this.slider1 = slider)}>
              <div className="slide_item">
                <img
                  src="/tm/react/toolways/assets/images/product/big_1.png"
                  className="image-fit-contain"
                  alt="img"
                />
              </div>
              <div className="slide_item">
                <img
                  src="/tm/react/toolways/assets/images/product/grid/1.png"
                  className="image-fit-contain"
                  alt="img"
                />
              </div>
              <div className="slide_item">
                <img
                  src="/tm/react/toolways/assets/images/product/grid/2.png"
                  className="image-fit-contain"
                  alt="img"
                />
              </div>
              <div className="slide_item">
                <img
                  src="/tm/react/toolways/assets/images/product/grid/4.png"
                  className="image-fit-contain"
                  alt="img"
                />
              </div>
            </Slider>
            <Slider className="slidetwo" asNavFor={this.state.nav1} ref={slider => (this.slider2 = slider)} slidesToShow={3} swipeToSlide={true} focusOnSelect={true}>
              <div className="slide_item col-12">
                <img
                  src="/tm/react/toolways/assets/images/product/big_1.png"
                  className="image-fit-contain"
                  alt="img"
                />
              </div>
              <div className="slide_item col-12">
                <img
                  src="/tm/react/toolways/assets/images/product/grid/1.png"
                  className="image-fit-contain"
                  alt="img"
                />
              </div>
              <div className="slide_item col-12">
                <img
                  src="/tm/react/toolways/assets/images/product/grid/2.png"
                  className="image-fit-contain"
                  alt="img"
                />
              </div>
              <div className="slide_item col-12">
                <img
                  src="/tm/react/toolways/assets/images/product/grid/4.png"
                  className="image-fit-contain"
                  alt="img"
                />
              </div>
            </Slider>
          </div>
    </div>
  );
}
}
// export default ShopDetailSlider